import Skeleton from "@/v2-ui/skeleton"

const LOADING_ROW_IDS = ["a", "b", "c", "d", "e", "f"] as const

// A pane's shape while it loads: a few name-and-count rows.
function LicenseFeatureGroupRegistryPaneSkeleton() {
  return (
    <ul className="flex flex-col gap-2 p-2">
      {LOADING_ROW_IDS.map((id) => (
        <li key={id} className="flex items-center gap-2">
          <Skeleton className="h-3 w-28" />
          <Skeleton className="ml-auto h-3 w-6" />
        </li>
      ))}
    </ul>
  )
}

export default LicenseFeatureGroupRegistryPaneSkeleton
